export const urlWithSeparator = (path: string) => {
  const separator = path.includes("?") ? "&" : "?";
  const updatedPath = `${path}${separator}t=${Date.now()}`;
  return updatedPath;
};
